var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"form-group",class:{
        row: _vm.row,
        'v-center': _vm.row,
    },attrs:{"id":_vm.$attrs.id ? `form-group-${_vm.$attrs.id}` : undefined}},[(_vm.$scopedSlots.label)?_c('label',{staticClass:"form-control-label",class:{
            'col-sm-3': _vm.row,
            'stretch': !_vm.row,
        },attrs:{"for":_vm.$attrs.id ? `form-control-label-${_vm.$attrs.id}` : _vm.htmUniqueId}},[_vm._t("label")],2):_vm._e(),_c('div',{staticClass:"input-group input-group-merge",class:{
            'col-sm-9': _vm.row,
        },attrs:{"id":_vm.$attrs.id ? `form-input-group-${_vm.$attrs.id}` : undefined}},[_vm._t("content",null,{"htmUniqueId":_vm.$attrs.id ? `form-control-label-${_vm.$attrs.id}` : _vm.htmUniqueId})],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }